module.exports = __webpack_public_path__ + "static/media/cluster_widget.a3b96b51.jpg";